const forestData = require("./forestData.json");

const stateTransitions = {
  ".1": {
    title: "1. Alive &#8594; Alive in CR",
    percentage: "82.9%",
    total: 2653
  },
  ".3": {
    title: "2. Alive in CR &#8594; Alive with Relapse",
    percentage: "50.2%",
    total: 1331
  },
  ".2": {
    title: "3. Alive &#8594; Death without CR",
    percentage: "16.5%",
    total: 529
  },
  ".4": {
    title: "4. Alive in CR &#8594; Death in CR",
    percentage: "13.3%",
    total: 352
  },
  ".5": {
    title: "5. Alive with Relapse &#8594; Death with Relapse",
    percentage: "77.0%",
    total: 1025
  }
};

const componentLabels = {
  age: "Age",
  ahdno: "Antecedent of Hematological Disorder - No",
  ahdyes: "Antecedent of Hematological Disorder - Yes",
  bm_blasts: "Bone Marrow Blasts",
  full_component_CEBPA_bi: "Full Component - CEBPA_BI",
  full_component_DNMT3A_IDH1_2: "Full Component - DNMT3A_IDH1_2",
  full_component_inv_16: "Full Component - inv(16)",
  full_component_inv_3: "Full Component - inv(3)",
  full_component_mNOS: "Full Component - mNOS",
  full_component_no_events: "Full Component - No Events",
  full_component_NPM1: "Full Component - NPM1",
  full_component_sAML1: "Full Component - sAML1",
  full_component_sAML2: "Full Component - sAML2",
  full_component_t_11: "Full Component - t(11)",
  full_component_t_15_17: "Full Component - t(15;17)",
  full_component_t_6_9: "Full Component - t(6;9)",
  full_component_t_8_21: "Full Component - t(8;21)",
  full_component_TP53_complex: "Full Component - TP53 Complex",
  full_component_Trisomies: "Full Component - Trisomies",
  full_component_WT1: "Full Component - WT1",
  genderFemale: "Gender - Female",
  genderMale: "Gender - Male",
  hb: "Hemoglobin",
  ITD: "ITD",
  "perf_statuscapable of selfcare but no work activities":
    "Perf. Status - Capable of Selfcare but no work activities",
  "perf_statuscompletely disabled": "Perf. Status - Completely disabled",
  perf_statusFullyactive: "Perf. Status - Fully active",
  "perf_statuslimited selfcare": "Perf. Status - Limited selfcare",
  "perf_statusRestricted in physical activity":
    "Perf. Status - Restricted in physical activity",
  plt: "Platelet Count",
  secondaryde_novo: "Secondary - De novo",
  secondarysecondary: "Secondary - Secondary",
  secondarytAML: "Secondary - tAML",
  wbc: "White Blood Count"
};

export { stateTransitions, forestData, componentLabels };
